import React, { memo } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import { PREFIX } from '@zmedia/bm-soccer-ui/constants';
import styles from './navbar.module.scss';

interface IProps {
    className?: string;
    children: React.ReactNode;
    active?: boolean;
}

function NavbarMenu(props: IProps) {
    const { children, className, active, ...rest } = props;

    return (
        <Element
            {...rest}
            renderAs="ul"
            className={classnames(styles[`${PREFIX}-navbar-menu`], className, {
                [styles['is-active']]: active,
            })}
        >
            {children}
        </Element>
    );
}

export default memo(NavbarMenu);
